'use strict';

exports.__esModule = true;
exports.phasesConfig = undefined;
exports.create = create;
exports.setFactory = setFactory;

var _env = require('./env');

var _conf = require('./conf');

var _reporter = require('./reporter/reporter');

var _reporter2 = _interopRequireDefault(_reporter);

var _baseLogger = require('./base-logger');

var _baseLogger2 = _interopRequireDefault(_baseLogger);

var _appData = require('./app-data/app-data');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ReporterFactory = void 0;

function getAppVersion() {
  return (0, _env.env)().__CI_APP_VERSION__ || _conf.DEFAULT_APP_VERSION;
}

/*
 * @param baseUrl
 * @param appId
 * @param disableAutoLoadFinish
 * @param interactionTimeout
 * @param timeoutHook
 * @param startHook
 * @param endHook
 * @param biLoggerFactory
 */
function create(appName) {
  var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  if (!appName) {
    return null;
  }

  (0, _appData.initializeGlobal)(appName);
  var reporter = createReporterInstance(params);
  return new _baseLogger2.default(appName, getAppVersion(), reporter, params);
}

function setFactory(factory) {
  ReporterFactory = factory;
}

function createReporterInstance(_ref) {
  var biLoggerFactory = _ref.biLoggerFactory,
      baseUrl = _ref.baseUrl;

  if (!ReporterFactory) {
    return new _reporter2.default(biLoggerFactory, baseUrl);
  } else {
    return ReporterFactory(biLoggerFactory, baseUrl);
  }
}

var phasesConfig = exports.phasesConfig = _baseLogger.phasesConfigValues;